import React, {
  createContext,
  useState,
  useEffect,
  useCallback,
  useMemo,
} from "react";

const SidebarContext = createContext();

const SidebarContextProvider = ({ children }) => {
  const [showMenu, setShowMenu] = useState(() => {
    // Check if device is mobile and set sidebar to closed by default
    const isMobile = window.innerWidth <= 768;
    return isMobile; // Closed on desktop (true), open on mobile (false)
  });

  useEffect(() => {
    if (showMenu) {
      document.body.classList.add("sidebar-toggled");
    } else {
      document.body.classList.remove("sidebar-toggled");
    }
  }, [showMenu]);

  // Handle window resize to adjust sidebar state for mobile/desktop
  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth <= 768;
      // If switching to mobile, close sidebar; if switching to desktop, open sidebar
      if (isMobile && !showMenu) {
        setShowMenu(true);
      } else if (!isMobile && showMenu) {
        setShowMenu(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [showMenu]);

  const toggleSidebar = useCallback(() => {
    setShowMenu((prev) => !prev);
  }, []);

  const contextValue = useMemo(
    () => ({
      showMenu,
      setShowMenu,
      toggleSidebar,
    }),
    [showMenu, toggleSidebar]
  );

  return (
    <SidebarContext.Provider value={contextValue}>
      {children}
    </SidebarContext.Provider>
  );
};

export { SidebarContext, SidebarContextProvider };

